export default __webpack_public_path__ + "static/media/3.videotrivia.a032051c.png";